/** Angular Imports */
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

/** rxjs Imports */
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

/** Custom Services */
import { ClientsService } from '../clients.service';

/**
 * Client Template resolver.
 */
@Injectable()
export class ClientTemplateResolver {
  private clientsService = inject(ClientsService);

  /**
   * Returns the Client Template data.
   * @returns {Observable<any>}
   */
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.clientsService.getClientTemplate().pipe(catchError(() => of(null)));
  }
}